import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { setCatNav, categorySelectedTrigger } from './../redux/actions';
import PageWrapper from './../components/PageWrapper';
import Hero from './../components/hero/Hero';
import CategoryNavWrapper from './../components/filter-pages/CategoryNavWrapper';
import FilmArtGrid from './../components/filter-pages/FilmArtGrid';
import { filterCategory, splitString, removeHidden } from './../scripts';

class FilmLanding extends Component {
  componentWillMount() {
    this.props.setCatNav(this.props.staticContent.filmData.data.film_landing_category_navigation);
    this.props.categorySelected(splitString(this.props.route));
  };
  render() {
    return (
      <PageWrapper pageId={'portfolio-landing'}>
        <Hero sliderContent={this.props.staticContent.filmData.data.hero_slider}/>
        <CategoryNavWrapper/>
        <FilmArtGrid
          GridItems={filterCategory(removeHidden(this.props.staticContent.filmData.data.film_grid), this.props.category)}
          Page={'film'}
        />
      </PageWrapper>
    );
  };
};

export default connect(
  state => ({
    route: state.router.location_data.pathname,
    staticContent: state.staticContent,
    category: state.current_sub_category
  }),
  dispatch => ({
    setCatNav: (navigation) => dispatch(setCatNav(navigation)),
    categorySelected: (category) => dispatch(categorySelectedTrigger(category))
  })
)(FilmLanding);



// WEBPACK FOOTER //
// ./src/pages/FilmLanding.js